import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable import/no-cycle */
import React, { useMemo, useState, useCallback } from "react";
import RadioGroup from "../RadioGroup";
import Radio from "../Radio";
import FormControlLabel from "../FormControlLabel";
import FormControl from "../FormControl";
import Box from "../Box";
import { ClearButton } from "../ListAppliedFilterChip";
import { createEmptyAppliedFilter } from '.';
const ListFilterSingleRadio = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref;
  const [expanded, setExpanded] = useState(false);
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes
  ]);
  const handleChangeValue = useCallback((_e, value) => {
    if (value != null) {
      const findOption = searchFilter.options.find(option => option.value === value);
      if (!findOption) {
        onChangeAppliedFilter(searchFilter, null);
        return;
      }
      const filterValues = []; //Note: even though its single select we commonize the way we pass back data in an array
      const filterValue = {
        value: findOption.value,
        label: findOption.label,
        context: null
      };
      filterValues.push(filterValue);
      const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
      newAppliedSearchFilter.filterValues = filterValues;
      newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(findOption.label);
      onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  const value = (appliedFilterValues === null || appliedFilterValues === void 0 ? void 0 : appliedFilterValues.length) > 0 ? appliedFilterValues[0].value : "";
  const limit = (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.showMoreLimit) || 10;
  const labelShowMore = (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.labelShowMore) || "Show More";
  const labelShowLess = (searchFilter === null || searchFilter === void 0 ? void 0 : searchFilter.labelShowLess) || "Show Less";
  const overrideExpanded = searchFilter.options.findIndex(option => option.value === value) > limit - 1;
  const visibleOptions = overrideExpanded ? searchFilter.options : searchFilter.options.length > limit && !expanded ? searchFilter.options.slice(0, limit) : searchFilter.options;
  const handleExpandContract = e => {
    e.preventDefault();
    setExpanded(!expanded);
  };
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(RadioGroup, {
    ref: ref,
    "aria-label": searchFilter.label,
    value: value,
    name: "radio-buttons-group".concat(searchFilter.id),
    onChange: handleChangeValue
  }, visibleOptions.map((option, i) => /*#__PURE__*/React.createElement(FormControlLabel, {
    key: i,
    value: option.value,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: option.label
  }))), !overrideExpanded && searchFilter.options.length > limit && /*#__PURE__*/React.createElement(ClearButton, {
    onClick: handleExpandContract
  }, expanded || overrideExpanded ? labelShowLess : labelShowMore)));
});
export default ListFilterSingleRadio;